import React from 'react'
import logo from '../../assets/general/bluedoorLogo.svg'
import mail from '../../assets/general/social/Icon-mail.svg'
import mobile from '../../assets/general/social/Icon-mobile.svg'
import location from '../../assets/general/social/Icon-Location.svg'
import fb from '../../assets/general/social/Icon-Fb.svg'
import linkedin from '../../assets/general/social/Icon-linkdn.svg'
import insta from '../../assets/general/social/Icon-insta.svg'
import twitter from '../../assets/general/social/Icon-twiter.svg'

import { useNavigate } from 'react-router-dom'

const Footer = () => {

  const d = new Date();

  const year = d.getFullYear();

  const navigate = useNavigate()

  return (
    <div className='bg-[#272939] text-[#fff]  px-6 md: px-12 lg:px-28 py-12' >

      <div className='grid grid-cols-11 pb-16 gap-x-4 md:gap-y-8' >
          <div className='hidden lg:flex col-span-2 lg:col-span-1 justify-center' >
            <img className='h-[50%]' src={logo} alt="" />
          </div>

          <div className='col-span-9 md:col-span-4 lg:col-span-4 flex flex-col gap-4' >
            <h3 className='text-2xl font-mosk600' >Get in touch</h3>
            <div className='flex flex-col gap-3' >
            <div className='flex items-start gap-5'>
                <div className='flex gap-4 items-start' >
                    <img className='w-[20px]' src={mobile} alt="" />
                    {/* <p>Mobile:</p> */}
                </div>
                <span className='flex gap-1 text-md' >
                    <a href="tel:+919052224966"><p>9052224966</p></a>
                    <p>/</p>
                    <a href="tel:+917207872864"><p>7207872864</p></a>
                </span>
            </div>
            <div className='flex items-start gap-4' >
                <div className='flex gap-4' >
                    <img className='w-[20px] relative top-[7px]' src={mail} alt="" />
                    {/* <p>Email:</p> */}
                </div>
                <span className='flex flex-col text-md' >
                    <a href="mailto:admin@bluedoorevents.in"><p>admin@bluedoorevents.in</p></a>
                    <a href="mailto:sapna@bluedoorevents.in"><p>sapna@bluedoorevents.in</p></a>
                </span>
            </div>
            <div className='flex items-start gap-4' >
                <div className='flex gap-4 items-start' >
                    <img className='w-[20px]' src={location} alt="" />
                    {/* <p>Address:</p> */}
                </div>
                <span className='text-md  md:pl-0' >
                    <p>Blue Door Event Solutions</p>
                    <p>#101 Dhruv apartmetns, first floor</p>
                    <p>Street #10, Nehru Nagar, East Marredpally,</p>
                    <p>Secunderabad 500026</p>
                </span>
            </div>
        </div>   
          </div>
          {/* <div className='col-span-2 '></div> */}
          <ul className='pl-8 md:pl-0 col-span-6 md:col-span-3 lg:col-span-2  flex flex-col gap-2 py-8 lg:py-0' >
            <li onClick={()=> navigate("/approach")} className='text-xl font-mosk600' >How we see it</li>
            <li onClick={()=> navigate("/projects")} >Macro Approach</li>
            <li onClick={()=> navigate("/casestudy/1")}>Micro Approach</li>
          </ul>

          <ul className=' col-span-5 md:col-span-2 lg:col-span-2  flex flex-col gap-2 py-8 lg:py-0' >
            <li onClick={()=> navigate("/approach")} className='text-xl font-mosk600' >Our Work</li>
            <li onClick={()=> navigate("/projects")} >Projects</li>
            <li onClick={()=> navigate("/casestudy/1")}>Case Studies</li>
            <li onClick={()=> navigate("/casestudy/1")}>Blog</li>
          </ul>

          <ul className='pl-8 md:pl-0 col-span-4 md:col-span-2 lg:col-span-2 flex flex-col gap-2 py-8 lg:py-0'>
            <li onClick={()=> navigate("/company")} className='text-xl font-mosk600'>Company</li>
            <li onClick={()=> navigate("/about-us")}>About Us</li>
            <li onClick={()=> navigate("/company")}>Meet The Team</li>
            <li onClick={()=> navigate("/")}>Contact Us</li>
          </ul>

          <div className='hidden lg:flex col-span-2 lg:col-span-1 ' ></div>

          <div className='col-span-11 pl-8 lg:pl-0 md:col-span-4 lg:col-span-2 flex gap-8 lg:gap-0  lg:justify-between  h-full items-end'>
            <a href="https://www.facebook.com/profile.php?id=100063697580015&mibextid=ZbWKwL" target='_blank'><img className='h-[25px]' src={fb} alt="" /></a>
            <a href="https://www.linkedin.com/in/blue-door-event-solutions-652a03172/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" target='_blank'><img className='h-[25px]' src={linkedin} alt="" /></a>
            <a href="https://www.instagram.com/bluedooreventsolutions_hyd/?igsh=eTV1bThhZXUzdDU%3D" target='_blank'><img className='h-[25px]' src={insta} alt="" /></a>
            <a href="https://x.com/i/flow/login?redirect_after_login=%2FBlueDoorEvent" target='_blank'><img className='h-[25px]' src={twitter} alt="" /></a>
          </div>

      </div>

      <hr />

      <div className='w-full flex flex-col md:flex-row gap-2 justify-between pt-6' >
        <p>© Copyright {year}. All rights reserved.</p>
        <p>Made with ❤️ in Hyderabad*</p>
      </div>
    </div>
  )
}

export default Footer
